import { getCardModule } from 'helpers/offer.helpers';
import PotentialScoreFactorsModuleView from './PotentialScoreFactorsModuleView';
import { usePotentialScoreFactorsModule } from './hooks/PotentialScoreFactorsModule.hooks.js';
import { useScrollToTop } from 'hook/helper.hook';

const PotentialScoreFactorsModuleController = props => {
  const { moduleList, eventHandler, history, userInfo, location, config } =
    props;
  const { additionalData } = getCardModule(
    moduleList,
    'POTENTIAL_ALL_BUREAU_SCORES_CREDIT_FACTORS',
  );

  const {
    handleClickInFactor,
    handleClickBereauReport,
    handleClickOpeningNewCreditCard,
    handleClickGettingNewCard,
    handleClickOpenAccountToday,
    handleClickExploreAllPremiumBenefits,
  } = usePotentialScoreFactorsModule({
    eventHandler,
    history,
    userInfo,
    location,
  });

  useScrollToTop([location]);

  return (
    <PotentialScoreFactorsModuleView
      paymentHistory={additionalData?.paymentHistory}
      creditUsage={additionalData?.creditUsage}
      creditAge={additionalData?.creditAge}
      accountMix={additionalData?.accountMix}
      creditInquiries={additionalData?.inquiries}
      eventHandler={eventHandler}
      history={history}
      handleClickInFactor={handleClickInFactor}
      handleClickOpeningNewCreditCard={handleClickOpeningNewCreditCard}
      handleClickBereauReport={handleClickBereauReport}
      handleClickGettingNewCard={handleClickGettingNewCard}
      handleClickOpenAccountToday={handleClickOpenAccountToday}
      handleClickExploreAllPremiumBenefits={
        handleClickExploreAllPremiumBenefits
      }
      config={config}
      userInfo={userInfo}
    />
  );
};

export default PotentialScoreFactorsModuleController;
